import { UserTypeEnum, UserDetail } from '../../../js/api';
import { resolveRoleHome } from './roleHomeRoutes';

/**
 * Determines the home URL for a user based on their user type and current location.
 * This centralizes the logic for where users should be redirected when clicking on logos.
 *
 * @param user - The current user object (can be undefined if not logged in)
 * @param pathname - The current pathname from the location (e.g., from useLocation hook)
 * @returns The home URL string for the user
 */
export function getHomeUrl(user: UserDetail | undefined, pathname: string): string {
  const isAppPage =
    pathname.startsWith('/app/healthcare-entity') ||
    pathname.startsWith('/app/organization') ||
    pathname.startsWith('/app/provider');

  if (user?.user_type === UserTypeEnum.PROVIDER) {
    return '/app/provider/home';
  } else if (user?.user_type === UserTypeEnum.HEALTHCARE_ENTITY_REP) {
    return resolveRoleHome(user.healthcare_entity_rep_role, '/app/healthcare-entity');
  } else if (user?.user_type === UserTypeEnum.STAFF) {
    return '/staff/home';
  } else {
    return 'https://www.senditgigs.com/';
  }
}
